import React from 'react';
import { PageHero, SectionTitle, Card } from '../components/PageUI';

const TermosPage = () => (
  <div>
    <PageHero
      eyebrow="Termos de uso"
      title="Condições para uso dos serviços Zartoo."
      subtitle="Leia atentamente as regras de uso e responsabilidades."
      primaryCta={{ label: 'Falar com suporte', href: '/suporte' }}
    />
    <section className="bg-white text-slate-900">
      <div className="container mx-auto px-8 lg:px-12 py-16">
        <SectionTitle
          eyebrow="Termos"
          title="Principais tópicos"
          description="Resumo das condições contratuais."
          mode="light"
        />
        <div className="grid md:grid-cols-2 gap-6">
          {['Aceitação', 'Licença de uso', 'Responsabilidades', 'Suporte e garantias', 'Rescisão'].map((item) => (
            <Card key={item} variant="light">
              <h3 className="text-xl font-semibold">{item}</h3>
              <p className="text-slate-600 mt-2">Consulte nosso time para informações detalhadas.</p>
            </Card>
          ))}
        </div>
      </div>
    </section>
  </div>
);

export default TermosPage;
